<template>
<span id="add-shuttle-file" v-if="showAddShuttleFile()">
  <el-button id="btn-add-shuttlefile" type="success" plain @click="dialogVisible = true" size="mini">{{ $t('routing.shuttleFile.addShuttleFile') }}</el-button>
  <el-dialog
  :close-on-click-modal="false"
  v-on:open="handleOpen"
  :title="$t('routing.shuttleFile.addShuttleFile')"
  :visible.sync="dialogVisible"
  width="65%"
  class="dialog-with-cols"
  :before-close="handleClose">
  <el-form :model="form" :rules="formRules" ref="form" label-position="top" size="mini">
    <el-row>
      <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
        <el-form-item :label="$t('routing.shuttleFile.receivingWarehouse')" prop="warehouse" class="inline-input">
          <el-input
          v-model="form.warehouse"
          disabled
          class="inline-input"
          id="form-warehouse"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
        <el-form-item :label="$t('routing.shuttleFile.receivingDate')" prop="receivingDate" class="inline-input">
          <el-date-picker
            class="el-dropdown-new drop-sp date-dob"
            v-model="form.receivingDate"
            format="MM/dd/yyyy"
            clearable
            type="date"
          ></el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
        <el-form-item :label="$t('routing.shuttleFile.consignee')" prop="consigneeAccountId" class="inline-input">
          <autocomplete :model.sync="form.consigneeAccountId"
            :shipperAccountId="null"
            labelFieldLastWithDash="number"
            popperAppendToBody
            :url="urlConsignee"
            labelField="name"
            valueField="id"
            id="rows-consignee"
            ref="rows-consignee" />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
        <el-form-item :label="$t('routing.shuttleFile.outboundWarehouse')" class="inline-input" prop="outboundWarehouseId">
          <outbound-warehouse-select :value.sync="form.outboundWarehouseId" :includeOptionAll="false" ref="outbound-warehouse"/>
        </el-form-item>
      </el-col>
      <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
        <el-form-item :label="$t('routing.shuttleFile.outboundDate')" prop="outboundDate" class="inline-input">
          <el-date-picker
            class="el-dropdown-new drop-sp date-dob"
            v-model="form.outboundDate"
            format="MM/dd/yyyy"
            clearable
            type="date"
          ></el-date-picker>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
  <div id="add-dialog-footer" slot="footer" class="dialog-footer form-vertical-item flex-reverse-direction">
      <el-button type="primary" id="form-save-button" @click="submitForm()" size="mini">{{ $t('routing.shuttleFile.addShuttleFile') }}</el-button>
      <el-button id="form-refresh-button" @click="resetForm()" size="mini">{{ $t('routing.shuttleFile.clear') }}</el-button>
  </div>
  </el-dialog>
</span>
</template>

<script>
import { Message } from 'element-ui';
import { mapGetters } from 'vuex';
import constants from '@/utils/constants';
import apiConstants from '@/utils/apiConstants';
import Autocomplete from '@/components/Autocomplete';
import OutboundWarehouseSelect from '../../components/OutboundWarehouseSelect';

export default {
  name: 'AddShuttleFile',
  components: { Autocomplete, OutboundWarehouseSelect },
  computed: {
    ...mapGetters([
      'shuttleFile',
      'user'
    ]),
    daysOptions() {
      return constants.DAYS_OPTIONS.filter(option => option.value != null);
    }
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        warehouse: '',
        receivingWarehouseId: null,
        consigneeAccountId: null,
        receivingDate: null,
        outboundDate: null,
        outboundWarehouseId: null,
        shuttle: false
      },
      formRules: {
        consigneeAccountId: [
          { required: true, message: this.$t('routing.shuttleFile.errors.consigneeRequired'), trigger: 'submit' }
        ],
        outboundWarehouseId: [
          { required: true, message: this.$t('routing.shuttleFile.errors.outboundWarehouseRequired'), trigger: 'blur' }
        ],
        receivingDate: [
          { required: true, message: this.$t('routing.shuttleFile.errors.receivingDateRequired'), trigger: 'blur' }
        ],
        outboundDate: [
          { required: true, message: this.$t('routing.shuttleFile.errors.outboundDateRequired'), trigger: 'blur' }
        ]
      },
      urlConsignee: apiConstants.END_POINTS.ACCOUNTS.CONSIGNEE
    };
  },
  methods: {
    handleOpen() {
      this.$nextTick(() => {
        this.resetForm();
      });
    },
    handleClose(done) {
      this.resetForm();
      done();
    },
    async updateUnits(shuttleFile) {
      const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
      await this.$store.dispatch('shuttleFile/updateRelatedUnits', shuttleFile)
        .then(response => this.$message.success(response.message))
        .finally(() => loading.close());
    },
    async confirmUpdateUnits(id) {
      const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
      try {
        const shuttleFile = { id };
        const response = await this.$store.dispatch('shuttleFile/getUnitsToUpdateAllCountSummary', shuttleFile);
        loading.close();
        if (response && response.data && response.data.pending > 0) {
          const message = this.$t('routing.shuttleFile.pendingUnitsConfirmation').replace('[unitsPending]', response.data.pending)
            .concat(this.$t('routing.shuttleFile.continueConfirmation'));
          const confirm = await this.$confirm(message, { dangerouslyUseHTMLString: true, confirmButtonText: this.$t('common.yes') }).catch(() => false);
          if (confirm) {
            await this.updateUnits(shuttleFile);
          }
        }
      } catch (e) {
        loading.close();
      }
    },
    submitForm() {
      return new Promise((resolve) => {
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            Message.closeAll();
            const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
            this.$store
              .dispatch('shuttleFile/save', this.form)
              .then(async (response) => {
                loading.close();
                this.$message.success(response.message);
                await this.confirmUpdateUnits(response.data);
                this.resetForm();
                this.$store.dispatch('shuttleFile/search', {});
                resolve(response);
              })
              .catch(() => {
                loading.close();
              });
          } else {
            resolve(new Error(this.$t('common.invalid')));
          }
        });
      });
    },
    resetForm() {
      this.$refs.form.resetFields();
      this.clearAutocomplete();
      this.form.warehouse = this.user.warehouseCode;
      this.form.receivingWarehouseId = this.user.warehouseId;
      this.form.receivingDate = this.shuttleFile.actualFilters.receivingDate;
      this.form.outboundDate = this.shuttleFile.actualFilters.receivingDate;
      this.form.outboundWarehouseId = this.shuttleFile.actualFilters.outboundWarehouseId;
      this.$refs['outbound-warehouse'].setSelectedWarehouse(this.form.outboundWarehouseId);
      this.form.shuttle = false;
    },
    clearAutocomplete() {
      this.form.consigneeAccountId = null;
      this.$refs['rows-consignee'].clearLocalModel();
    },
    showAddShuttleFile() {
      return this.$can(this.permissions.ROUTING.EDIT_SHUTTLE_FILE);
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
#add-shuttle-file .el-select, .el-date-editor {
  width: 100%;
}
</style>
